<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-form ref="form"  @submit.prevent="userSignIn" lazy-validation>
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Login form</v-toolbar-title>               
                </v-toolbar>
                <v-card-text>              
                    <v-text-field prepend-icon="person" name="login" label="Login" type="text" v-model="login" :rules="loginRules" required></v-text-field>
                    <v-text-field id="password" prepend-icon="lock" name="password" label="Password" type="password" :rules="loginRules" v-model="password" required></v-text-field>
                </v-card-text>
                <v-card-actions>          
                <v-alert type="error" dismissible v-model="alert">
                  {{ error }}
                </v-alert>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" type="submit" @click="userSignIn">Login</v-btn>
                </v-card-actions>
                </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      login: '', 
      loginRules: [
        v => !!v || 'Is required',      
      ],  
      password: '', 
      alert: false
    }
  },
  methods: {
    userSignIn () {
      if(this.$refs.form.validate())
        this.$store.dispatch('userSignIn', { login: this.login, password: this.password });
    }
  },
  computed: {
    error () {
      return this.$store.state.error;
    },
    loading () {
      return this.$store.state.loading;
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.alert = true;
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null);
      }
    }
  },
};
</script>